import { EventEmitter, Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Configuration } from "../config/config";
import "rxjs/add/operator/map";
import { BehaviorSubject, Subject } from "rxjs";

@Injectable()
export class UserService {
  queValue: boolean = false;
  subject = new Subject<any>();
  private messageSource = new BehaviorSubject(this.queValue);
  currentMessage = this.messageSource.asObservable();
  currentUser = JSON.parse(localStorage.getItem("currentUser"));
  public jwtToken: string;
  public isCommunity: string;
  private user1= new BehaviorSubject<Object>({});
  cast =this.user1.asObservable();

  constructor(private http: HttpClient) {
    const theUser: any = JSON.parse(localStorage.getItem("currentUser"));
    if (theUser) {
      this.jwtToken = theUser.token;
    }
  }

  editUser1(user1){
    this.user1.next(user1)
  }


  refreshToken() {
    const theUser: any = JSON.parse(localStorage.getItem("currentUser"));
    if (theUser) {
      this.jwtToken = theUser.token;
    }
  }

  //retriving contact list
  getUsers() {
    return this.http
      .get(Configuration.ServerWithApiUrl + "/users")
      .map((res: any) => res);
  }

  // add new contact
  registerUser(oUser) {
    // return this.http
    //   .post(Configuration.Server + "register", oUser)
    //   .map((res: any) => res);

     return this.http
      .post(Configuration.ServerWithApiUrl + "/register", oUser)
      .map((res: any) => res);
  }

  saveCertfTargetDate(targetDate) {
    return this.http
      .post(Configuration.ServerWithApiUrl + "/certfTargetDate", targetDate)
      .map((res: any) => res);
  }

  getTargetDate(targetDateData) {
    return this.http
      .put(
        Configuration.ServerWithApiUrl + "/getCertfTargetDate",
        targetDateData
      )
      .map((res: any) => res);
  }

  // Create Batch
  createBatch(batchObj) {
    return this.http
      .post(Configuration.ServerWithApiUrl + "/batch", batchObj)
      .map((res: any) => res);
  }

  // add selected users in batch

  addUserData(userObj) {
    return this.http
      .post(Configuration.ServerWithApiUrl + "/addUserToBatch", userObj)
      .map((res: any) => res);
  }

  // Get Batch User Info
  getBatchUser(batch_id) {
    return this.http
      .get(Configuration.ServerWithApiUrl + "/getUserByBatchId/" + batch_id)
      .map((res: any) => res);
  }

  // Get Users id by Batch Info
  getUserIdsByBatch(batch_id) {
    return this.http
      .get(Configuration.ServerWithApiUrl + "/getUserIdsByBatchId/" + batch_id)
      .map((res: any) => res);
  }

  // Get Courses Assigned for Batch
  getAssignBatchCourses(batch_id) {
    return this.http
      .get(
        Configuration.ServerWithApiUrl +
          "/getCourseAssignedByBatchId/" +
          batch_id
      )
      .map((res: any) => res);
  }

  // Get Courses Assigned for Batch
  getAssignBatchJourneys(batch_id) {
    return this.http
      .get(
        Configuration.ServerWithApiUrl+'/getJourneyAssignedByBatchId/'+batch_id
        // Configuration.ServerWithApiUrl+'/getJourneyAssignedByBatchId/'+batch_id+'/'+comm_id
        
      )
      .map((res: any) => res);
  }

  // Get Certificate Assigned for Batch
  getAssignBatchCertificate(batch_id) {
    return this.http
      .get(
        // Configuration.ServerWithApiUrl+'/getCertificateAssignedByBatchId/'+batch_id+'/'+comm_id 
        Configuration.ServerWithApiUrl+'/getCertificateAssignedByBatchId/'+batch_id 
      )
      .map((res: any) => res);
  }

  getAssignBatchCertificateForUnorganize(unorganize){
    return this.http
      .get(
        Configuration.ServerWithApiUrl +
          "/getAssignBatchCertificateForUnorganize/" +
          unorganize
      )
      .map((res: any) => res);
  }

  // Delete Batch

  deleteBatch(batch_id) {
    return this.http
      .delete(Configuration.ServerWithApiUrl + "/batch/" + batch_id)
      .map((res: any) => res);
  }

  deleteAdminUser(userId) {
    return this.http
      .delete(Configuration.ServerWithApiUrl + "/deleteUser/" + userId)
      .map((res: any) => res);
  }

  /// Mail Sending
  sendmaillink(mailObj) {
    return this.http
      .post(Configuration.ServerWithApiUrl + "/sendmaillink", mailObj)
      .map((res: any) => res);
  }

  /// Mail Sending to Alignor
  sendmailAlignorlink(mailObj) {
    return this.http
      .post(Configuration.ServerWithApiUrl + "/sendmailAlignorlink", mailObj)
      .map((res: any) => res);
  }

  /// Username Recovery Sending to Alignor by Name
  unameRecoveryToAlignor(mailObj) {
    return this.http
      .post(Configuration.ServerWithApiUrl + "/unameRecoveryToAlignor", mailObj)
      .map((res: any) => res);
  }

  /// Username Recovery Sending to Alignor by Email
  unameRecoveryByEmailToAlignor(mailObj) {
    return this.http
      .post(
        Configuration.ServerWithApiUrl + "/unameRecoveryByEmailToAlignor",
        mailObj
      )
      .map((res: any) => res);
  }

  ///User Info

  getUserInfo(user_id) {
    return this.http
      .get(Configuration.ServerWithApiUrl + "/userinfo/" + user_id)
      .map((res: any) => res);
  }

  getAssignedContentByUserId(comm_id,user_id){
    return this.http.get(Configuration.ServerWithApiUrl+'/getAssignedContentByUserId/'+comm_id + '/' + user_id)
    .map((res: any)=>res)
  }

  ///Show User Info into batch accordion

  getUserInfoShow(user_id) {
    return this.http
      .get(Configuration.ServerWithApiUrl + "/userinfo/" + user_id)
      .map((res: any) => res);
  }

  //delete contact

  deleteUser(id) {
    return this.http
      .delete(Configuration.ServerWithApiUrl + "/user/" + id)
      .map((res: any) => res);
  }

  deleteUserByCommunity(user_name, communityID) {
    return this.http
      .delete(
        Configuration.ServerWithApiUrl +
          "/communityUsers/" +
          communityID +
          "/" +
          user_name
      )
      .map((res: any) => res);
  }

  getClientData(id) {
    if (id == undefined || id == null || id == "") {
      //id='QWxpZ25vcg==';
      // id='eyJjb21tdW5pdHlOYW1lIjoiQWxpZ25vciIsImNvbW11bml0eUlEIjoiYWxpZ25vckNvbW0iLCJwdXJwb3NlIjoibG9naW4ifQ=='; ///for default Alignor company
      id =
        "eyJjb21tdW5pdHlOYW1lIjoiTm9uZSIsImNvbW11bml0eUlEIjoiZ2xvYmFsIiwicHVycG9zZSI6ImxvZ2luIn0=="; ///for default Alignor company
    } else {
    }
    return this.http
      .get(Configuration.Server + "client/" + id)
      .map((res: any) => res);
  }

  addBulkUser(obj) {
    return this.http
      .post(Configuration.Server + "register", obj)
      .map((res: any) => res);
  }

  addBulkUserNew(obj) {
    return this.http
      .post(Configuration.ServerWithApiUrl + "/register/bulk_user", obj)
      .map((res: any) => res);
  }

  addSingleUser(obj) {
    return this.http
      .post(Configuration.ServerWithApiUrl + "/singleUser", obj)
      .map((res: any) => res);
  }

  IschangePassword(id) {
    // return this.http
    //   .get(Configuration.Server + "changePSW/" + id)
    //   .map((res: any) => res);

    return this.http
      .get(Configuration.ServerWithApiUrl + "/changePSW/" + id)
      .map((res: any) => res);
  }

  changePassword(changePwdObj) {
    // return this.http
    //   .post(Configuration.Server + "updatePwd", changePwdObj)
    //   .map((res: any) => res);

    return this.http
    .post(Configuration.ServerWithApiUrl + "/updatePwd", changePwdObj)
    .map((res: any) => res);
  }

  getUserRole(user_id) {
    return this.http
      .get(Configuration.ServerWithApiUrl + "/userRole/" + user_id)
      .map((res: any) => res);
  }

  changeLanguage(userObj) {
    return this.http
      .post(Configuration.ServerWithApiUrl + "/changeLang", userObj)
      .map((res: any) => res);
  }

  getPopUpUsers(batchId, communityID) {
    return this.http
      .get(
        Configuration.ServerWithApiUrl +
          "/getAssignedUser/" +
          batchId +
          "/" +
          communityID
      )
      .map((res: any) => res);
  }

  getPopUpUsersWithoutBatch(batchId, communityID, params) {
    return this.http
      .post(
        Configuration.ServerWithApiUrl +
          "/getPopUpUsersWithoutBatch/" +
          batchId +
          "/" +
          communityID,
        params
      )
      .map((res: any) => res);
  }

  getUsersWithoutBatchByCommId(communityID, params) {
    return this.http
      .post(
        Configuration.ServerWithApiUrl +
          "/getUsersWithoutBatchByCommId/" +
         
          communityID,
        params
      )
      .map((res: any) => res);
  }

  getAllUsersWithoutBatch(communityID, params) {
    return this.http
      .post(
        Configuration.ServerWithApiUrl +
          "/getAllUsersWithoutBatch/" +
         
          communityID,
        params
      )
      .map((res: any) => res);
  }

  getMessages(user_id) {
    const theUser: any = JSON.parse(localStorage.getItem("currentUser"));
    if (theUser) {
      this.jwtToken = theUser.token;
    }

    return this.http
      .get(Configuration.ServerWithApiUrl + "/message/" + user_id)
      .map((res: any) => res);
  }

  checkExpiry(user_id) {
    return this.http
      .get(Configuration.ServerWithApiUrl + "/checkForExpiry/" + user_id)
      .map((res: any) => res);
  }

  getCommunityUsers(communityID) {
    return this.http
      .get(Configuration.ServerWithApiUrl + "/communityUsers/" + communityID)
      .map((res: any) => res);
  }

  updateCommunityUsers(data) {
    console.log("data of service user==>", data);
    return this.http
      .put(Configuration.ServerWithApiUrl + "/updateCommunityUser", data)
      .map((res: any) => res);
  }
  getSubLicenseById(id) {
    return this.http
      .get(Configuration.ServerWithApiUrl + "/userlicensebyid/" + id)
      .map((res: any) => res);
  }

  getLicenseById(id) {
    return this.http
      .get(Configuration.ServerWithApiUrl + "/licensebyid/" + id)
      .map((res: any) => res);
  }

  getCouponsByCode(code) {
    return this.http
      .get(Configuration.ServerWithApiUrl + "/getCouponByCode/" + code)
      .map((res: any) => res);
  }

  updateUsedCoupos(data) {
    return this.http
      .put(Configuration.ServerWithApiUrl + "/coupons", data)
      .map((res: any) => res);
  }

  updateSubscribeLicense(data) {
    return this.http
      .put(Configuration.ServerWithApiUrl + "/updateLicenseForUser", data)
      .map((res: any) => res);
  }

  getSelectedCommunity(commid) {
    return this.http
      .get(Configuration.ServerWithApiUrl + "/getSelectedCommunity/" + commid)
      .map((res: any) => res);
  }

  getCommunityByCommunityID(communityID) {
    return this.http
      .get(Configuration.ServerWithApiUrl + "/communities/" + communityID)
      .map((res: any) => res);
  }

  getRoleAndBusinessUnitById(communityID) {
    return this.http
      .get(
        Configuration.ServerWithApiUrl +
          "/getRoleAndBusinessUnitById/" +
          communityID
      )
      .map((res: any) => res);
  }

  getCommunityNameByCommunityID(communityID) {
    return this.http
      .get(Configuration.ServerWithApiUrl + "/communityName/" + communityID)
      .map((res: any) => res);
  }

  getAllCommunities() {
    return this.http
      .get(Configuration.ServerWithApiUrl + "/communitiesnames")
      .map((res: any) => res);
  }

  getAllBatches(commid) {
    return this.http
      .get(
        Configuration.ServerWithApiUrl + "/getBatchDataByCommunityId/" + commid
      )
      .map((res: any) => res);
  }

  getAllBatchesUser(commid) {
    return this.http
      .get(
        Configuration.ServerWithApiUrl + "/getBatchUserByCommunityId/" + commid
      )
      .map((res: any) => res);
  }

  changeConfiguration(Obj) {
    return this.http
      .post(Configuration.ServerWithApiUrl + "/community/config", Obj)
      .map((res: any) => res);
  }

  getCommunityLogo(commId) {
    return this.http
      .get(Configuration.ServerWithApiUrl + "/communityLogo/" + commId)
      .map((res: any) => res);
  }

  getMsgById(msgId) {
    return this.http
      .get(Configuration.ServerWithApiUrl + "/message_by_id/" + msgId)
      .map((res: any) => res);
  }

  getBatch(batch_id) {
    return this.http
      .get(Configuration.ServerWithApiUrl + "/batch/" + batch_id)
      .map((res: any) => res);
  }

  deleteUserFromBatch(Obj) {
    return this.http
      .post(Configuration.ServerWithApiUrl + "/batch/user", Obj)
      .map((res: any) => res);
  }
  getSelectedUserInfo(data) {
    return this.http
      .post(Configuration.ServerWithApiUrl + "/getSelectedUserInfo", data)
      .map((res: any) => res);
  }

  addAlignorAdmin(Obj) {
    return this.http
      .post(Configuration.ServerWithApiUrl + "/alignor_user", Obj)
      .map((res: any) => res);
  }

  registerAlignor(oUser) {
    return this.http
      .post(Configuration.ServerWithApiUrl + "/alignor_admin", oUser)
      .map((res: any) => res);
  }

  getSecurityQuestions(lang_id) {
    return this.http
      .get(Configuration.ServerWithApiUrl + "/security_questions/" + lang_id)
      .map((res: any) => res);
  }

  getNotification(user_name) {
    const theUser: any = JSON.parse(localStorage.getItem("currentUser"));
    if (theUser) {
      this.jwtToken = theUser.token;
    }

    return this.http
      .get(Configuration.ServerWithApiUrl + "/notification/" + user_name)
      .map((res: any) => res);
  }

  getUsersbyCommunity(commid) {
    return this.http
      .get(Configuration.ServerWithApiUrl + "/getCommunityAdmin/" + commid)
      .map((res: any) => res);
  }

  markReadMsg(obj) {
    return this.http
      .put(Configuration.ServerWithApiUrl + "/message", obj)
      .map((res: any) => res);
  }
  getOrganizationName(org_id) {
    return this.http
      .get(Configuration.ServerWithApiUrl + "/organization/" + org_id)
      .map((res: any) => res);
  }
  getCommunityByName(name) {
    return this.http
      .get(Configuration.ServerWithApiUrl + "/getCommunityByName/" + name)
      .map((res: any) => res);
  }

  checkPassword(obj) {
    return this.http
      .post(Configuration.ServerWithApiUrl + "/confirmPassword", obj)
      .map((res: any) => res);
  }

  assignBulkLicensestoUsers(data) {
    return this.http
      .post(Configuration.ServerWithApiUrl + "/assignBulkLicensetoUsers", data)
      .map((res: any) => res);
  }

  changeAdminStatus(data) {
    return this.http
      .put(Configuration.ServerWithApiUrl + "/userStatusChange", data)
      .map((res: any) => res);
  }

  updateUser(data) {
    return this.http
      .put(Configuration.ServerWithApiUrl + "/user", data)
      .map((res: any) => res);
  }

  updateUserKYC(data) {
    return this.http
      .put(Configuration.ServerWithApiUrl + "/updateUserKYC", data)
      .map((res: any) => res);
  }

  changeProfileImage(Obj) {
    return this.http
      .put(Configuration.ServerWithApiUrl + "/change_profile_pic", Obj)
      .map((res: any) => res);
  }
  usersProfilePic(user_id) {
    const theUser: any = JSON.parse(localStorage.getItem("currentUser"));
    if (theUser) {
      this.jwtToken = theUser.token;
    }

    return this.http
      .get(Configuration.ServerWithApiUrl + "/user_info/" + user_id)
      .map((res: any) => res);
  }

  checkForCommunityAdmin(obj) {
    return this.http
      .put(Configuration.ServerWithApiUrl + "/users", obj)
      .map((res: any) => res);
  }

  getAllCommunitiesManagedBy() {
    return this.http
      .get(Configuration.ServerWithApiUrl + "/managedBy_comunity")
      .map((res: any) => res);
  }

  getUserDuplicateData(obj) {
    //user_data_duplication

    return this.http
      .post(Configuration.ServerWithApiUrl + "/user_data_duplication", obj)
      .map((res: any) => res);
  }

  getOtherCommunity(id) {
    return this.http
      .get(Configuration.ServerWithApiUrl + "/other_community/" + id)
      .map((res: any) => res);
  }

  changeUserCommunity(obj) {
    return this.http
      .put(Configuration.ServerWithApiUrl + "/change_user_comm", obj)
      .map((res: any) => res);
  }

  updateNotification(obj) {
    return this.http
      .put(Configuration.ServerWithApiUrl + "/update_notification", obj)
      .map((res: any) => res);
  }

  getAllProtectedCommunity() {
    return this.http
      .get(Configuration.ServerWithApiUrl + "/protected_communities")
      .map((res: any) => res);
  }

  getAllLanguage() {
    this.refreshToken();

    return this.http
      .get(Configuration.ServerWithApiUrl + "/language")
      .map((res: any) => res);
  }

  getLang() {
    return this.http
      .get(Configuration.ServerWithApiUrl + "/lang")
      .map((res: any) => res);
  }

  updatePassword(data) {
    return this.http
      .post(Configuration.ServerWithApiUrl + "/update_password", data)
      .map((res: any) => res);
  }
  deleteSelectedUsers(data) {
    return this.http
      .put(Configuration.ServerWithApiUrl + "/deleteSelectedUsers", data)
      .map((res: any) => res);
  }

  changeSelectedUserCommunity(data) {
    return this.http
      .put(
        Configuration.ServerWithApiUrl + "/changeSelectedUserCommunity",
        data
      )
      .map((res: any) => res);
  }

  getIntroVideo() {
    return this.http
      .get(Configuration.ServerWithApiUrl + "/getIntroVideo")
      .map((res: any) => res);
  }

  getAllGamesTotalScore(user_id) {
    return this.http
      .get(Configuration.ServerWithApiUrl + "/getAllGamesTotalScore/" + user_id)
      .map((res: any) => res);
  }

  getResourceConfiguration(commid) {
    return this.http
      .get(Configuration.ServerWithApiUrl + "/getResourceConfig/" + commid)
      .map((res: any) => res);
  }

  sendSupportInquiry(data) {
    return this.http
      .post(Configuration.ServerWithApiUrl + "/supportInquiry", data)
      .map((res: any) => res);
  }

  getSupportQue() {
    return this.http
      .get(Configuration.ServerWithApiUrl + "/getSupportQuestion")
      .map((res: any) => res);
  }

  checkUserExist(user_name) {
    return this.http
      .get(Configuration.ServerWithApiUrl + "/checkUserExist/" + user_name)
      .map((res: any) => res);
  }

  securityAttemptMailToAdmin(mailObj) {
    return this.http
      .post(
        Configuration.ServerWithApiUrl + "/securityAttemptMailToAdmin",
        mailObj
      )
      .map((res: any) => res);
  }

  exportUserResetDetails(data) {
    return this.http
      .post(Configuration.ServerWithApiUrl + "/exportUserResetDetails", data)
      .map((res: any) => res);
  }

  setResetLinkTrack(data) {
    return this.http
      .post(Configuration.ServerWithApiUrl + "/setResetLinkTrack", data)
      .map((res: any) => res);
  }

  removeSelectedUsersFromBatch(Obj) {
    return this.http
      .post(
        Configuration.ServerWithApiUrl + "/removeSelectedUsersFromBatch",
        Obj
      )
      .map((res: any) => res);
  }

  moveSelectedUsersFromBatch(Obj) {
    return this.http
      .post(Configuration.ServerWithApiUrl + "/moveSelectedUsersFromBatch", Obj)
      .map((res: any) => res);
  }

  moveSelectedUnOrganizedUsers(Obj) {
    // alert("unorganized move");
    return this.http
      .post(Configuration.ServerWithApiUrl + "/moveSelectedUnOrganizedUsers", Obj)
      .map((res: any) => res);
  }

  // selected language api
  getSelectedLanguageLearner(user_id) {
    return this.http
      .get(Configuration.ServerWithApiUrl + "/userLangId/" + user_id)
      .map((res: any) => res);
  }

  setSelectedLanguageLearner(data) {
    return this.http
      .put(Configuration.ServerWithApiUrl + "/setUserLangId", data)
      .map((res: any) => res);
  }

  changeSecurityQuestionNAnswer(user_id, data) {
    return this.http
      .put(
        Configuration.ServerWithApiUrl + "/securityQuestionNAnswer/" + user_id,
        data
      )
      .map((res: any) => res);
  }

  getSecurityQuestionNAnswerPopup(user_id) {
    return this.http
      .get(Configuration.ServerWithApiUrl + "/userInformation/" + user_id)
      .map((res: any) => res);
  }

  // getSecurityQueAnswerPopup(lang_id) {
  //   return this.http
  //     .get(Configuration.ServerWithApiUrl + "/findQuestionFromLang/" + lang_id)
  //     .map((res: any) => res);
  // }

  getUserIdbyUserName(username: string) {
    return this.http
      .get(Configuration.ServerWithApiUrl + "/userName/" + username)
      .map((res: any) => res);
  }
  setSeqQues(username: string, value) {
    console.log("service call ", value);
    let obj: any = {
      seq_Que: value,
    };
    return this.http
      .post(Configuration.ServerWithApiUrl + "/setSeqQues/" + username, obj)
      .map((res: any) => res);
  }

  setSeqQuesForUsers(userIds:any, value) {
    let obj: any = {
      seq_Que: value,
      userIds: userIds,
    };
    return this.http
      .post(Configuration.ServerWithApiUrl + "/setSeqQuesForUsers", obj)
      .map((res: any) => res);
  } 

  setVarQues(value: boolean) {
    console.log("userService queValue", value);
    this.messageSource.next(value);
  }
  getVarQues(): boolean {
    return this.queValue;
  }

// check for token change
checkForToken(token,community_id){
  return this.http
  .get(Configuration.ServerWithApiUrl + "/userNameExist/"+token+"/"+community_id)
  .map((res: any) => res);

}

getCognitoLinkFromSSObtn(comm_id){
  return this.http
      .get(Configuration.ServerWithApiUrl + "/ssoUrl/"+comm_id)
      .map((res: any) => res);
}

getSocialBtnFromUserPool(user_pool){
  return this.http
  .get(Configuration.ServerWithApiUrl + "/userpool/"+ user_pool)
  .map((res: any) => res);
}

getRegisterFromSSO(token,obj){
  return this.http
  .post(Configuration.ServerWithApiUrl + "/signUp/" + token, obj)
  .map((res: any) => res);
}

getRegisterDatafromCommunityID(obj){
  return this.http.post(Configuration.ServerWithApiUrl + '/sso_info',obj )
    .map((res: any) => res)
}

getAuthenticationTypeCommunity(obj){
  console.log('1234',obj);
  return this.http.post(Configuration.ServerWithApiUrl + '/communityAuthType',obj )
    .map((res: any) => res)
}

getCreateBatch(obj){
  return this.http.post(Configuration.ServerWithApiUrl + '/batchCreate',obj )
    .map((res: any) => res)
}

getInviteUser(obj){
  return this.http.post(Configuration.ServerWithApiUrl + '/individualUser',obj )
    .map((res: any) => res)
}

getLicencesByCommId(commId){
  // alert(commId);
  return this.http.get(Configuration.ServerWithApiUrl+'/getLicenseList_by_commID/'+commId)
      .map((res: any)=>res)

}
getInvitedUserforShow(obj){
  return this.http.post(Configuration.ServerWithApiUrl + '/invite',obj )
    .map((res: any) => res)
}
SendEmailToSupportConfigure(commId:any,obj){
  return this.http.post(Configuration.ServerWithApiUrl + '/supportEmail/' + commId,obj )
    .map((res: any) => res )
}

getBatchIdFromBatchNameSSO(commId, batchName){
  // let params = new HttpParams().set('batch_name', batchName);
  let params = new HttpParams();

  if (batchName) {
    params = params.append('batch_name', batchName);
  }
 
  return this.http.get(Configuration.ServerWithApiUrl + '/community/'+ commId +'/batch', {params: params})
  .map((res: any) => res )
}

checkExpiryDate(group_id) {
    return this.http
      .get(Configuration.ServerWithApiUrl + "/expiryDetailsByGroupId/" + group_id)
      .map((res: any) => res);
  }

}





// WEBPACK FOOTER //
// ./src/app/Services/Users.service.ts